import Vue from "vue";
import VueRouter from 'vue-router'
import axios from "axios";
import Login from "../views/Login.vue";
import { loginData } from "../data";
import RegistroInstitucion from "../views/RegistroInstitucion.vue";
import Inicio from "../views/Inicio.vue";
import { inicioData } from "../data";
import CambioContrasea from "../views/CambioContrasea";
import { cambioContraseaData } from "../data";
import Error404 from "../views/Error404";
import { error404Data } from "../data";
import Main from "../views/Main";
import MenuHeader from "../components/MenuHeader";
import RecuperarContrasena from "../views/RecuperarContrasena"
import { RecuperarcontrasenaData } from "../data";
import ModalGeneral from "../components/ModalGeneral";
import ModalNotifi from "../components/ModalNotifi";
import Registro from "../views/Configuracion/Registro";
import ListaUsuarios from "../views/Configuracion/ListaUsuarios";
import ParametrosGenerales from "../views/Configuracion/ParametrosGenerales";
import CambiosContraseaInicio from "../views/CambiosContraseaInicio";
import InformacionPersonal from "../views/Perfil/InformacionPersonal";
import { modalData } from "../data";
import { ModalErrorData } from "../data";
import Cielum from "../components/Cielum";
import { cielumData } from "../data";
import MensajeEnviado from "../components/MensajeEnviado";
import { rectanguloData } from "../data";
import Error500 from "../views/Error500";
import { error500Data } from "../data";
import Error401 from "../views/Error401";
import E401 from "../views/401";
import { error401Data } from "../data";
import CreacionContrasenaSlide from "../views/CreacionContrasenaSlide";
import { CreacioncontrasenaslideData } from "../data";
import { CambiosContraseaInicioData } from "../data";
import MisSolicitudes from "../views/Clientes/MisSolicitudes";
import CrearSolicitudes from "../views/Clientes/CrearSolicitudes";
import HistorialSolicitudes from "../views/Clientes/HistorialSolicitudes";
import PHistorialSolicitudes from "../views/Proveedores/HistorialSolicitudes";
import PMisSolicitudes from "../views/Proveedores/MisSolicitudes";
import SolicitudesEspecificas from "../views/Proveedores/SolicitudesEspecificas";
import SolicitudesGenerales from "../views/Proveedores/SolicitudesGenerales";
import SolicitudesRetiro from "../views/Proveedores/SolicitudesRetiro";
import SolicitudesDevueltas from "../views/Proveedores/SolicitudesDevueltas.vue";
import GestionRetiroIndependiente from "../views/Proveedores/GestionRetiroIndependiente.vue";
import RecepcionSolicitudes from "../views/Prestadores/RecepcionSolicitudes";
import RecepcionRetirosIndependientes from "../views/Prestadores/RecepcionRetirosIndependientes.vue";
import CrearSolicitudRetiro from "../views/Clientes/CrearSolicitudRetiro.vue";
import MisRetirosIndependientes from "../views/Clientes/MisRetirosIndependientes.vue";
import DashboardSolicitudes from "../views/Prestadores/DashboardaSolicitudes";
import HistoricoCliente from "../views/Prestadores/HistoricoCliente.vue";
import HistoricoProveedor from "../views/Prestadores/HistoricoProveedor.vue";
import HistoricoPacientes from "../views/Prestadores/HistoricoPacientes.vue";
import Clientes from "../views/Configuracion/Clientes.vue";
import Proveedores from "../views/Configuracion/Proveedores.vue";
import DisponibilidadEquipos from "../views/Proveedores/DisponibilidadEquipos.vue";
import BitacoraAuditoria from "../views/Configuracion/BitacoraAuditoria.vue";
import AdminListados from "../views/Configuracion/AdminListados.vue";
import GestionSolicitudes from "../views/Configuracion/GestionSolicitudes.vue";
import GestionAutorizaciones from "../views/Aseguradores/GestionAutorizaciones.vue";
//import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import InformeSolicitudes from "../views/Prestadores/InformeSolicitudes.vue";
import InformeAuditor from "../views/Prestadores/InformeAuditor.vue";
import AuditoriaOxyflow from "../views/Prestadores/AuditoriaOxyflow.vue";

//const perfil = RepositoryFactory.get("perfil");
Vue.use(VueRouter)

const routes = [{
        path: "/",
        name: "login",
        props: {...loginData },
        component: Login
    },
    {
        path: "/login",
        name: "login",
        props: {...loginData },
        component: Login
    },
    {
        path: "/registro-institucion",
        name: "registroInstitucion",
        component: RegistroInstitucion,
        props: {
            logo: "/img/logo.png",
            cielumProps: "/img/Sin t\u00edtulo.png",
        },
    },
    {
        path: "/CambioContrasea",
        name: "CambioContrasea",
        props: {...cambioContraseaData },
        component: CambioContrasea
    },

    {
        path: "/CreacionContrasenaSlide",
        name: "CreacionContrasenaSlide",
        props: {...CreacioncontrasenaslideData },
        component: CreacionContrasenaSlide
    },

    {
        path: "/recuperarcontrasena",
        name: "recuperarcontrasena",
        props: {...RecuperarcontrasenaData },
        component: RecuperarContrasena
    },
    {
        path: "/loginn",
        name: "loginn",
        component: ModalGeneral,
        props: {...ModalErrorData },
    },
    {
        path: "/Modal",
        name: "Modal",
        component: ModalNotifi,
        props: {...modalData },
    },
    {
        path: "/cielum",
        name: "cielum",
        component: Cielum,
        props: {...cielumData },
    },
    {
        name: "mensajeEnviado",
        path: "/mensajeEnviado",
        component: MensajeEnviado,
        props: {...rectanguloData },
    },

    {
        path: "/error401",
        name: "error401",
        component: Error401,
        props: {...error401Data },
    },
    {
        path: "/401",
        name: "401",
        component: E401,
        props: {...error401Data },
    },
    {
        path: "/error404",
        name: "error404",
        props: {...error404Data },
        component: Error404
    },
    {
        path: "/error500",
        name: "error500",
        props: {...error500Data },
        component: Error500
    },
    {
        path: "/prm",
        component: Main,
        meta: { requiresAuth: true },
        children: [{
                path: "/inicio",
                props: {...inicioData },
                component: Inicio,
                meta: { requiresAuth: true },
            },
            {
                path: "/registro",
                name: "registro",
                component: Registro,
                meta: { requiresAuth: true },
            },
            {
                path: "/lista-usuarios",
                name: "lista-usuarios",
                component: ListaUsuarios,
                meta: { requiresAuth: true },
            },
            {
                path: "/parametros-generales",
                name: "parametros-generales",
                component: ParametrosGenerales,
                meta: { requiresAuth: true },
            },
            {
                path: "/cambio-contrasena-inicio",
                name: "cambio-contrasena-inicio",
                component: CambiosContraseaInicio,
                meta: { requiresAuth: true },
                props: {...CambiosContraseaInicioData },
            },
            {
                path: "/informacion-personal",
                name: "informacion-personal",
                component: InformacionPersonal,
                meta: { requiresAuth: true },
            },
            {
                path: "/clientes-mis-solicitudes",
                name: "clientes-mis-solicitudes",
                component: CrearSolicitudes,
                meta: { requiresAuth: true },
            },
            {
                path: "/mis-solicitudes",
                name: "mis-solicitudes",
                component: MisSolicitudes,
                meta: { requiresAuth: true },

            }, {
                path: "/historial-solicitudes",
                name: "historial-solicitudes",
                component: HistorialSolicitudes,
                meta: { requiresAuth: true },

            },
            {
                path: "/proveedor-solicitudes-generales",
                name: "proveedor-solicitudes-generales",
                component: SolicitudesGenerales,
                meta: { requiresAuth: true },
            },
            {
                path: "/proveedor-solicitudes-especificas",
                name: "proveedor-solicitudes-especificas",
                component: SolicitudesEspecificas,
                meta: { requiresAuth: true },
            }, {
                path: "/proveedor-mis-solicitudes",
                name: "proveedor-mis-solicitudes",
                component: PMisSolicitudes,
                meta: { requiresAuth: true },
            }, {
                path: "/proveedor-historial-solicitudes",
                name: "proveedor-historial-solicitudes",
                component: PHistorialSolicitudes,
                meta: { requiresAuth: true },
            },
            {
                path: "/proveedor-solicitud-retiro",
                name: "proveedor-solicitud-retiro",
                component: SolicitudesRetiro,
                meta: { requiresAuth: true },
            },
            {
                path: "/proveedor-solicitudes-devueltas",
                name: "proveedor-solicitudes-devueltas",
                component: SolicitudesDevueltas,
                meta: { requiresAuth: true },
            },
            {
                path: "/proveedor-gestion-retiro-independiente",
                name: "proveedor-gestion-retiro-independiente",
                component: GestionRetiroIndependiente,
                meta: { requiresAuth: true },
            },
            {
                path: "/prestador-recepcion-retiros-independientes",
                name: "prestador-recepcion-retiros-independientes",
                component: RecepcionRetirosIndependientes,
                meta: { requiresAuth: true },
            },
            {
                path: "/cliente-crear-solicitud-retiro",
                name: "cliente-crear-solicitud-retiro",
                component: CrearSolicitudRetiro,
                meta: { requiresAuth: true },
            },
            {
                path: "/cliente-mis-retiros-independientes",
                name: "cliente-mis-retiros-independientes",
                component: MisRetirosIndependientes,
                meta: { requiresAuth: true },
            },
            {
                path: "/prestador-recepcion-solicitudes",
                name: "prestador-recepcion-solicitudes",
                component: RecepcionSolicitudes,
                meta: { requiresAuth: true },
            },
            {
                path: "/prestador-dashboard-solicitudes",
                name: "prestador-dashboard-solicitudes",
                component: DashboardSolicitudes,
                meta: { requiresAuth: true },
            },
            {
                path: "/prestador-historico-cliente",
                name: "prestador-historico-cliente",
                component: HistoricoCliente,
                meta: { requiresAuth: true },
            },
            {
                path: "/prestador-historico-proveedor",
                name: "prestador-historico-proveedor",
                component: HistoricoProveedor,
                meta: { requiresAuth: true },
            },
            {
                path: "/prestador-historico-pacientes",
                name: "prestador-historico-pacientes",
                component: HistoricoPacientes,
                meta: { requiresAuth: true },
            },
            {
                path: "/asegurador-gestion-autorizaciones",
                name: "asegurador-gestion-autorizaciones",
                component: GestionAutorizaciones,
                meta: { requiresAuth: true },
            },
            {
                path: "/clientes",
                name: "Clientes",
                component: Clientes,
                meta: { requiresAuth: true },
            },
            {
                path: "/proveedores",
                name: "Proveedores",
                component: Proveedores,
                meta: { requiresAuth: true },
            },
            {
                path: "/proveedor-disponibilidad-equipos",
                name: "proveedor-disponibilidad-equipos",
                component: DisponibilidadEquipos,
                meta: { requiresAuth: true },
            },
            {
                path: "/bitacora-auditoria",
                name: "bitacora-auditoria",
                component: BitacoraAuditoria,
                meta: { requiresAuth: true },
            },
            {
                path: "/admin-listados",
                name: "admin-listados",
                component: AdminListados,
                meta: { requiresAuth: true },
            },
            {
                path: "/informe-solicitudes",
                name: "informe-solicitudes",
                component: InformeSolicitudes,
                meta: { requiresAuth: true },
            },
            {
                path: "/gestion-solicitudes",
                name: "gestion-solicitudes",
                component: GestionSolicitudes,
                meta: { requiresAuth: true },
            },
            {
                path: "/informe-auditor",
                name: "informe-auditor",
                component: InformeAuditor,
                meta: { requiresAuth: true },
            },
            {
                path: "/auditoria-oxyflow",
                name: "auditoria-oxyflow",
                component: AuditoriaOxyflow,
                meta: { requiresAuth: true },
            },

        ]
    }
];

const router = new VueRouter({
    mode: "history",
    routes
});

router.beforeEach(async(to, from, next) => {


    const loggedIn = localStorage.getItem("userToken");

    var publicPageslogin = ["/inicio", "/registro", "/lista-usuarios", "/parametros-generales", "/informacion-personal", "/Modal", "/clientes-mis-solicitudes", "/mis-solicitudes", "/historial-solicitudes", "/proveedor-solicitudes-generales", "/proveedor-solicitudes-especificas", "/proveedor-mis-solicitudes", "/proveedor-historial-solicitudes", "/proveedor-solicitud-retiro", "/proveedor-solicitudes-devueltas",
        "/prestador-recepcion-solicitudes", "/prestador-dashboard-solicitudes", "/prestador-historico-cliente", "/prestador-historico-proveedor", "/prestador-historico-pacientes","/clientes","/proveedores","/proveedor-disponibilidad-equipos","/cambio-contrasena-inicio","/bitacora-auditoria","/admin-listados","/informe-solicitudes","/gestion-solicitudes","/asegurador-gestion-autorizaciones","/informe-auditor" ,"/auditoria-oxyflow",
        "/proveedor-gestion-retiro-independiente", "/prestador-recepcion-retiros-independientes", "/cliente-crear-solicitud-retiro", "/cliente-mis-retiros-independientes"
    ];

    var publicPageslogout = ["/", "/login", "/CambioContrasea",
        "/CreacionContrasenaSlide", "/recuperarcontrasena", "/loginn",
        "/Modal", "/cielum", "/mensajeEnviado",
        "/error401", "/401", "/error404", "/error500", "/inicio", "/registro","/clientes-mis-solicitudes",
        "/registro-institucion","/cambio-contrasena-inicio","/informacion-personal"
    ];

    var error = ["/error401", "/401", "/error404"];


    // Agregar función para verificar el acceso
    async function checkAccess() {
        try {
            const datosUser = localStorage.getItem('user');
            var datoUser = JSON.parse(datosUser);
            var idperfil = datoUser.id_perfil;
            //url: process.env.VUE_APP_BASE_API + "/perfil-menu?id_perfil=" + params.id_perfil,
            const headers = {
                Authorization: localStorage.getItem("userToken"),
                // Otros encabezados que puedas necesitar
            };

            const response = await axios.get(process.env.VUE_APP_BASE_API + "/perfil-permisos", {
                params: {
                    id_perfil: idperfil, // Reemplaza esto con la lógica para obtener el ID del perfil
                    path_url: to.path.replace("/", ""),
                },
                headers: headers,
            });

            console.log("acceso>>>", response.data);
            if (response.data.message.status) {
                // Si tiene acceso, continuar
                next();
            } else {
                // Si no tiene acceso, redirigir a la página de error404
                next('/error404');
            }
        } catch (error) {
            console.error('Error al verificar el acceso:', error);
            // Manejar errores, por ejemplo, redirigir a la página de error500
            next('/error500');
        }
    }


    if (loggedIn != null && typeof loggedIn != "undefined") {
        //if (to.path != "/" && to.path != "/login" && to.path != "/inicio" && to.path != "/error500" && to.path != "/error404" && to.path != "/error401") {
        if (!publicPageslogout.includes(to.path)) {
            console.log("buscars>>>>>>", to.path)
            await checkAccess();
        }

        if (to.path == "/") {
            return next("/inicio");
        }

        var existencia = publicPageslogin.filter(x => x == to.path).length;

        if (existencia == 0) {
            var existencia = publicPageslogout.filter((x) => x == to.path).length;
            var arrayerror = error.filter((x) => x == to.path).length;
            if (arrayerror > 0) {

                return next();
            } else if (existencia > 0) {

                return next("/inicio");
            } else {

                return next("/error404");
            }
        } else {
            return next();
        }



    } else {
        if (to.path == "/") {
            return next("/login");
        }

        var publicPages = publicPageslogout;
        var existencia = publicPageslogin.filter((x) => x == to.path).length;
        var existencialogout = publicPageslogout.filter((x) => x == to.path).length;
        var arrayerror = error.filter((x) => x == to.path).length;
        if (arrayerror > 0) {
            return next();
        } else if (existencia > 0) {

            return next("/login");
        } else if (existencialogout > 0) {

            return next();
        } else {

            return next("/error404");
        }

    }

    const authRequired = !publicPages.includes(to.path);
    if (!authRequired == false) {
        return next("/error404");
    }

    next();
});
export default router;